const DEFAULT_DURATION_MS = 100;

const BUTTON_SELECTOR = [
   "button",
   "[role='button']",
   "input[type='button']",
   "input[type='submit']",
   "input[type='reset']",
].join(", ");

function canUseHaptics() {
   return (
      typeof navigator !== "undefined" &&
      typeof navigator.vibrate === "function"
   );
}

function isTouchableDevice() {
   if (typeof window === "undefined") return false;

   return window.matchMedia("(pointer: coarse)").matches;
}

export function triggerHapticFeedback(durationMs = DEFAULT_DURATION_MS) {
   if (!canUseHaptics() || !isTouchableDevice()) return false;
   return navigator.vibrate(durationMs);
}

function isDisabledInteractive(el) {
   if (!el) return true;
   if (el.disabled) return true;
   if (el.getAttribute("aria-disabled") === "true") return true;
   if (el.classList?.contains("is-disabled")) return true;
   return false;
}

function resolveHapticTarget(target) {
   if (!target?.closest) return null;
   if (target.closest("[data-no-haptic]")) return null;

   const button = target.closest(BUTTON_SELECTOR);
   if (button && !isDisabledInteractive(button)) return button;

   const navLink = target.closest("a[href]");
   if (navLink && !isDisabledInteractive(navLink)) {
      const href = String(navLink.getAttribute("href") || "").trim();
      if (
         href.startsWith("/") &&
         navLink.target !== "_blank" &&
         !navLink.hasAttribute("download")
      ) {
         return navLink;
      }
   }

   return null;
}

export function bindGlobalHapticFeedback(root = document) {
   const onPress = (event) => {
      if (!resolveHapticTarget(event.target)) return;
      triggerHapticFeedback();
   };

   root.addEventListener("click", onPress, true);

   return () => {
      root.removeEventListener("click", onPress, true);
   };
}
